// FILTER BY OWNER/GC SIGN-OFF (owner, 2026-10-21). Three answers, any of
// them: signed off, planned (the star's day is still ahead), not signed off.
// The server judges each row exactly as the "Signed off by owner/GC" column
// does (utils/ownerSignOff), so the filter and the column cannot disagree.
//
// `value` and `onChange` are the comma string the query carries ("signed,not").
import React from "react";
import { Select, Tooltip } from "antd";
import { OWNER_STAR_BLUE, OWNER_STAR_PLANNED } from "./OwnerSignOffToggle";

export const OWNER_SIGNOFF_CHOICES = [
  { value: "signed", label: <span><span style={{ color: OWNER_STAR_BLUE }}>★</span> Signed off by owner/GC</span>, text: "Signed off" },
  { value: "planned", label: <span><span style={{ color: OWNER_STAR_PLANNED }}>★</span> Owner/GC sign-off planned</span>, text: "Planned" },
  { value: "not", label: "Not signed off by owner/GC", text: "Not signed off" },
];

export default function OwnerSignOffFilter({ value = "", onChange, disabled = false, width = 210, size }) {
  const picked = String(value || "").split(",").filter(Boolean);
  return (
    <Tooltip title={disabled ? "Pick a project first" : "The client's sign-off the GC marked on Levels, Areas & Systems: by the linked activity, the level, or the area and system on the row's level"}>
      <Select
        mode="multiple"
        maxTagCount="responsive"
        allowClear
        aria-label="Owner/GC sign-off filter"
        placeholder="Owner/GC sign-off"
        disabled={disabled}
        size={size}
        style={{ width }}
        value={picked}
        optionLabelProp="text"
        onChange={(v) => onChange((v || []).join(","))}
        options={OWNER_SIGNOFF_CHOICES}
      />
    </Tooltip>
  );
}
